<template>
    <div class="task-center" ref="scrollContainer" :class="{ 'padding-top': userStore.isPadTop }">
        <div class="title re_relative re_flex_center re_font_18 re_bg_white" :class="{ 'is-pad-top': userStore.isPadTop }">
            <van-icon @click="goBack()" class="icon" name="arrow-left" size="22" />
            <span>意见反馈</span>
        </div>
        <iframe :src="url" scrolling="auto" frameborder="0" class="trend-container2" id="iframe"></iframe>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { router } from '../router';

import { useUserStore } from '../stores/user';
import { useRoute } from 'vue-router';
const userStore = useUserStore();
const route = useRoute();
const goBack = () => {
    router.go(-1);
}
const url = ref('')
onMounted(() => {
    url.value = route.query.url
    console.log(route.query,url.value)
})
</script>

<style scoped lang="less">
.task-center {
    padding: 80px 0 0;
    background: #fff;
    height: calc(100vh - 80px);
    overflow-y: auto;
    .title {
        padding: 30px 0 18px 0;
        width: 100%;
        font-weight: 600;
        position: fixed;
        z-index: 10;
        left: 0;
        top: 0;
        .icon {
            position: absolute;
            left: 16px;
            bottom: 18px;
        }
    }
    .is-pad-top {
        padding-top: 46px;
    }
    .fixed-title {
        position: fixed;
        z-index: 100;
        left: 0;
        top: 60px;
        width: calc(100vw - 32px);
        padding: 0 16px;
        height: 44px;
        background: #fff;
        display: flex;
        justify-content: start;
        align-items: center;
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
        .fixed-item {
            min-width: 20%;
            margin-right: 16px;
        }
        .fixed-item-end {
            margin-left: auto;
        }
    }
    .isFixedTop {
        top: 76px;
    }
    .icon-down{
        width: 12px;
        height: 9px;
    }
}
#iframe {
    width: 100%;
    height: calc(100vh - 106px);
    border: none;
}
</style>
